import React from "react";
export default function ReviewBase({ children }) {
    return (
        <div >
           {children}
        </div>
    );
}
